<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">我的账号</li>
                <li class="active">地址管理</li>
                <li @click="orderjump(3)">我的优惠券</li>
            </ul>
        </div>
        <div class="newaddress_btn">
            <Button type="warning" @click="newaddressClick(1)">新建地址</Button>
        </div>
        <div class="orderdetails_table_content">
            <Table
                border
                ref="selection"
                :loading="tloading"
                :columns="thead"
                :data="infolist"></Table>
        </div>
        <!-- 分页 -->
        <div class="page_content">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
        <!-- 新建地址 -->
        <NewAddress :type="addresstype" :newaddresshows="newaddresshows" :addressinfo="addressinfo" @newaddressOk="newaddressOk" @newaddressCancel="newaddressCancel"></NewAddress>
    </div>
</template>

<script>
import api from '@/request/api.js'
import NewAddress from '@/components/component/popup/newaddress.vue'
export default {
    components: {NewAddress},
    data() {
        return {
            tloading: false, // 表格加载中
            newaddresshows: false, // 新建地址弹窗是否显示
            addresstype: 0, // 1 新建地址 2 编辑地址
            addressinfo: {}, // 编辑地址信息
            thead: [ // 表格头部
                {
                    align: 'center',
                    title: '公司名称',
                    key: 'shopname'
                },
                {
                    align: 'center',
                    title: '收货人',
                    key: 'contactname'
                },
                {
                    align: 'center',
                    title: '所在地区',
                    key: 'areaaddress'
                },
                {
                    align: 'center',
                    title: '详细地址',
                    key: 'detaddress',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'address_detalis_txt'
                                    },
                                    [
                                        h('span', params.row.detaddress),
                                        h('small', {style: {display: params.row.is_main == 1 ? 'inline-block' : 'none'}}, '默认地址'),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '操作',
                    key: 'operation',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'address_operation'
                                    },
                                    [
                                        h('span',
                                            {
                                                on: {
                                                    click: () => {
                                                        this.newaddressClick(2, params.row)
                                                    }
                                                }
                                            },
                                            '编辑'
                                        ),
                                        h('span',
                                            {
                                                style: {
                                                    display: params.row.is_main == 0 ? 'inline' : 'none'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.deladdress(params.row.is_main, params.row.id)
                                                    }
                                                }
                                            },
                                            '删除'
                                        ),
                                        h('span',
                                            {
                                                style: {
                                                    display: params.row.is_main == 0 ? 'inline' : 'none'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.setdefault(params.row.id)
                                                    }
                                                }
                                            },
                                            '设为默认'
                                        ),
                                    ]
                                )
                    }
                }
            ],
            infolist: [], // 表格列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.tloading = true
            this.http.post(api.address,
                {
                    page: this.pagecurrent,
                    pagesize: this.pagesize
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.infolist = response.data.msg.address_addresslist
                this.pagetotal = response.data.msg.address_pagecontent.num
                this.tloading = false
            })
            .catch(error => {
                this.noLogin(error)
            })
        },
        setdefault (id) { // 设置默认地址
            this.http.post(api.addressdefault, {addressid: id})
            .then(response => {
                this.$Message.success(response.data.msg)
                this.getInfo()
            })
            .catch(error => {
                this.noLogin(error)
            })
        },
        deladdress (istrue, id) { // 删除地址
            this.http.post(api.addressdel, {addressid: id})
            .then(response => {
                this.$Message.success(response.data.msg)
                this.getInfo()
            })
            .catch(error => {
                console.log(error)
            })
        },
        addaddress (info) { // 添加/修改地址
            console.log(info)
            this.http.post(api.addressadd, 
                {
                    addressid: this.addressinfo.id,
                    shopname: info.company,
                    contactname: info.name,
                    phone: info.phone,
                    detaddress: info.address,
                    fathercode: info.citycode[0],
                    cityadcode: info.citycode[1],
                    adcode: info.citycode[2],
                    fathercodename: info.city[0],
                    cityadcodename: info.city[1],
                    adcodename: info.city[2],
                    is_main: info.default ? 1 : 0
                }
            )
            .then(response => {
                this.$Message.success(response.data.msg)
                this.getInfo()
            })
            .catch(error => {
                this.noLogin(error)
            })
        },
        newaddressClick (sign, item) { // 新建地址
            this.newaddresshows = true
            this.addressinfo = ''
            this.addresstype = sign
            if (sign == 2) {
                this.addressinfo = item
            }
        },
        newaddressOk (e) { // 新建地址弹窗确定
            this.addaddress(e)
            this.newaddresshows = false
        },
        newaddressCancel () { // 新建地址弹窗取消
            this.newaddresshows = false
            this.addressinfo = {}
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Accounts'
            } else if (sign == 2) {
                link = '/Address'
            } else {
                link = '/MyCoupon'
            }
            this.$router.push(link)
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.newaddress_btn {
    padding: 20px 20px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/views/member/address.vue